import './ListBlock.scss'

import {Background} from '@codeurs/front'
import React, {useState} from 'react'
import {style} from 'util/style'
import {ImageType, LinkType, WysiwygType} from '../../types'
import {useTranslation} from '../../util/i18n'
import {Link} from '../../util/link'
import {Theme} from '../Theme'
import {Block} from './Blocks'

const styles = style('listblock', ['item'])

export type ListBlockType = {
	title: string
	inner_items: Array<ListItemBlockType>
}

type ListItemBlockType = {
	url?: string
	title: string
	preview_image?: ImageType
	preview_title?: string
	preview_text?: WysiwygType
	hero_image?: ImageType
	hero_title?: string
	hero_subtitle?: string
	hero_text?: WysiwygType
	cta?: LinkType
}

export const ListBlock: React.FC<ListBlockType & {container?: boolean}> = ({
	container,
	title,
	inner_items: items
}) => {
	return (
		<Block container={container} className={styles()}>
			{title && <Theme.H3 className={styles('title')}>{title}</Theme.H3>}
			{items.map((item, i) => (
				<ListItemBlock key={i} {...item} />
			))}
		</Block>
	)
}

export const ListItemBlock: React.FC<ListItemBlockType> = ({
	url,
	title: pageTitle,
	hero_image,
	hero_title,
	hero_subtitle,
	hero_text,
	preview_image,
	preview_title,
	preview_text,
	cta
}) => {
	const t = useTranslation('list')
	const [isHovered, setHovered] = useState(false)
	const image = preview_image || hero_image
	const title = preview_title || hero_title || pageTitle
	const text = preview_text || hero_text

	if (!image && !title && !text) return null

	return (
		<div className={styles.item().is({hovered: url && isHovered})}>
			<div className={styles.item('row')}>
				{image && (
					<Link
						to={url}
						className={styles.item('image')}
						onMouseOver={() => setHovered(true)}
						onMouseLeave={() => setHovered(false)}
					>
						<div className={styles.item('image-img')}>
							<Background
								img={image}
								className={styles.item('image-img-bg').toString()}
							/>
						</div>
					</Link>
				)}
				<div className={styles.item('content')}>
					{title && (
						<Theme.H3 className={styles.item('content-title')}>
							<Link
								to={url}
								className={styles.item('content-title-link')}
								onMouseOver={() => setHovered(true)}
								onMouseLeave={() => setHovered(false)}
							>
								{title}
							</Link>
						</Theme.H3>
					)}
					{hero_subtitle && (
						<p className={styles.item('content-subtitle')}>{hero_subtitle}</p>
					)}
					{text && (
						<div className={styles.item('content-text')}>
							<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
						</div>
					)}
					{cta?.url && (
						<Theme.Link to={cta?.url} className={styles.item('content-link')}>
							{cta?.description || cta?.title}
						</Theme.Link>
					)}
					{!cta?.url && url && (
						<Theme.Link to={url} className={styles.item('content-link')}>
							{t.view}
						</Theme.Link>
					)}
				</div>
			</div>
		</div>
	)
}
